document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.accordion details').forEach(function (details) {
    details.querySelector('summary').addEventListener('click', function (e) {
      if (!details.open) return;
      e.preventDefault();
      details.classList.add('is-closing');
      var content = details.querySelector('.accordion__content');
      content.addEventListener(
        'transitionend',
        function handler() {
          details.removeAttribute('open');
          details.classList.remove('is-closing');
        },
        { once: true }
      );
    });
  });
});
